import type { ContainerProps } from "@chakra-ui/react";
import { Container } from "@chakra-ui/react";
import React from "react";

export const PageContainer = ({ children, ...props }: ContainerProps) => (
  <Container
    maxWidth="1118px"
    p="8"
    {...props}
  >
    {children}
  </Container>
);
